// frontend/src/pages/LearningPath.tsx

import { Link } from 'react-router-dom';
import { useLearningPath } from '../hooks/useLearningPath';
import { PathNode } from '../components/learning-path/PathNode';
import { AISuggestionCard } from '../components/learning-path/AISuggestionCard';
import '../styles/learning-path.css';

export function LearningPathPage() {
  const { path, isLoading, error } = useLearningPath();

  if (isLoading) return <div className="courses-loading">Yükleniyor...</div>;
  if (error) return <div className="courses-error">{error}</div>;

  if (!path) {
    return (
      <div className="learning-path-page">
        <header className="learning-path-header">
          <h1>Öğrenme Haritası 🗺️</h1>
          <p>AI tarafından kişiselleştirilmiş öğrenme yolun</p>
        </header>
        <div className="courses-empty">
          Henüz bir derse başlamadın. Haritanın oluşması için önce bir kursa başla.
          <br />
          <Link to="/courses" className="dash-empty-cta">
            Derslere göz at →
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="learning-path-page">
      <header className="learning-path-header">
        <h1>Öğrenme Haritası 🗺️</h1>
        <p>AI tarafından kişiselleştirilmiş öğrenme yolun</p>
      </header>

      <div className="card learning-path-goal-card">
        <div className="learning-path-goal-row">
          <div className="learning-path-goal-icon">🎯</div>
          <div>
            <h3>Mevcut Hedef: {path.title}</h3>
            <p>
              {path.steps.find((s) => s.status === 'current')
                ? `Bir sonraki adım: ${path.steps.find((s) => s.status === 'current')!.title}`
                : 'Bu kursu tamamlamak üzeresin!'}
            </p>
          </div>
        </div>
        <div className="progress-bar">
          <div className="progress-bar-fill" style={{ width: `${path.progressPercent}%` }} />
        </div>
        <div className="learning-path-goal-footer">
          <span>{path.title}</span>
          <span>%{path.progressPercent} Tamamlandı</span>
        </div>
      </div>

      <div className="learning-path-nodes">
        {path.steps.map((step, i) => (
          <PathNode key={step.id} step={step} index={i} />
        ))}
      </div>

      <AISuggestionCard path={path} />
    </div>
  );
}
